import { UserJwt, Video } from "vimeo";

import { getContentBlockType, isContentBlockContext } from "./sessionStorage";
import { client as vimeoClient, getResponsiveOEmbed } from "./vimeoClient";

/**
 * The URI path prefix for content blocks.
 */
export const contentBlockPathPrefix = "contentblock";

/**
 * The origin that is passed to the Vimeo widget apps.
 */
export const appOrigin = `https://${window.location.host}`;

async function getUserJwt(): Promise<string> {
    const resp = await vimeoClient.post<UserJwt>("/api/vimeo/auth/jwt_token");
    return resp.data.token;
}

export async function onTrimVideoClicked(
    videoId: string | undefined
): Promise<Window | null> {
    if (!videoId) {
        return null;
    }

    const jwt = await getUserJwt();
    // For local client ID, use the app ID 244266.
    // Your local client ID should first be allowed
    // to use the above app ID by the Vimeo team.
    return window.open(
        `https://vimeo.com/widgets/apps/246282/videos/${videoId}/trimmer?user=${jwt}&origin=${appOrigin}`
    );
}

export async function openCreateGifWidget(
    videoId: string | undefined
): Promise<Window | null> {
    if (!videoId) {
        return null;
    }

    const jwt = await getUserJwt();
    // For local client ID, use the app ID 244266.
    // Your local client ID should first be allowed
    // to use the above app ID by the Vimeo team.
    return window.open(
        `https://vimeo.com/widgets/apps/246282/videos/${videoId}/gif/create?user=${jwt}&origin=${appOrigin}`
    );
}

export async function openCreateThumbnailWidget(
    videoId: string | undefined
): Promise<Window | null> {
    if (!videoId) {
        return null;
    }

    const jwt = await getUserJwt();
    // For local client ID, use the app ID 244266.
    // Your local client ID should first be allowed
    // to use the above app ID by the Vimeo team.
    return window.open(
        `https://vimeo.com/widgets/apps/246282/videos/${videoId}/thumbnail?user=${jwt}&origin=${appOrigin}`
    );
}

export function getVideoIdFromUri(uri: string): string {
    return uri.replace("/videos/", "").split(":")[0]; // also remove unlisted hash
}

export function getUserIdFromUri(uri: string): string {
    return uri.replace("/users/", "");
}

export function getRootPath(): string {
    if (isContentBlockContext()) {
        switch (getContentBlockType()) {
            case "email":
                return `/${contentBlockPathPrefix}/email`;
            case "web":
                return `/${contentBlockPathPrefix}/web`;
        }
    }

    return "/";
}

export async function getCloudPagesEmbedHtml(
    videoUri: string,
    playerEmbedUrl: string
): Promise<string> {
    // The `h` query-param is a special value that only applies to videos with
    // Unlisted video privacy.
    const hParam = new URL(playerEmbedUrl).searchParams.get("h");
    const videoId = getVideoIdFromUri(videoUri);
    const oembedResp = await getResponsiveOEmbed(videoId, hParam);

    return oembedResp.html;
}

export function getCloudPagesSuperContent(video: Video) {
    return `<div>
    <img src="${video.pictures.sizes[2].link}" title="${video.name}"/>
</div>`;
}
